<template>
  <Modal
    no-cancel
    :tracking="{ action: 'checkout', topicKey: 'neighbor-state-restriction' }"
    @confirm="emit('confirm')"
  >
    <template #headline>
      {{ $t('checkout.restrictions.geocheck.neighborstate.headline') }}
    </template>
    <i18n-t keypath="checkout.restrictions.geocheck.neighborstate.message" scope="global" tag="p">
      <template #contactSupport>
        <a class="text-link" :href="$localePath('/service?chat=true')">
          {{ $t('common.sentences.contactsupport').toLowerCase() }}
        </a>
      </template>
    </i18n-t>
    <template #confirm>
      {{ $t('checkout.restrictions.geocheck.neighborstate.confirm') }}
    </template>
  </Modal>
</template>

<script lang="ts" setup>
const emit = defineEmits<{ (e: 'confirm'): void }>()
</script>
